export default {
  TOGGLE: 'sideBar/TOGGLE',
  OPEN: 'sideBar/OPEN',
  CLOSE: 'sideBar/CLOSE',
  ACTIVE: 'sideBar/ACTIVE'
}
